/* --------------------------------------------------------------------------------------
   common.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/
import { commonService } from "./services/common.service";
import { apiClientService } from "./services/apiClient.service";
import { printService } from "./services/print.service";
import { persistService } from "./services/persist.service";
import { sessionDataService } from "./services/sessionData.service";
import { jobStatusService } from "./services/jobStatus.service";
import { deviceInfoService } from "./services/deviceInfo.service";
import { sessionService } from "./services/session.service";
import { xeroxSsoService } from "./services/xeroxSso.service";
import { ssoClientService } from "./services/ssoClient.service";
import { workflowScanningService } from "./services/workflowScanning.service";
import { snmpService } from "./services/snmp.service";

import { actionBarComponent } from "./components/actionBar.component";
import { textboxPopupComponent } from "./components/textboxPopup.component";
import { activityComponent } from "./components/activity.component";
import { calendarPopupComponent } from "./components/calendarPopup.component";
import { autoPostFormComponent } from "./components/autoPostForm.component";

import { imageLoaded } from "./directives/imageLoaded.directive";
import { xdaCalendar } from "./directives/xdaCalendar.directive";
import { onTap } from "./directives/onTap.directive";

import "./styles/pignose.calendar.css";
import "./styles/xdaCalendar.less";

export const appCommonModule = angular
  .module("app.common", [])
  .service("commonService", commonService)
  .service("apiClientService", apiClientService)
  .service("printService", printService)
  .service("persistService", persistService)
  .service("sessionDataService", sessionDataService)
  .service("jobStatusService", jobStatusService)
  .service("deviceInfoService", deviceInfoService)
  .service("sessionService", sessionService)
  .service("xeroxSsoService", xeroxSsoService)
  .service("ssoClientService", ssoClientService)
  .service("workflowScanningService", workflowScanningService)
  .service("snmpService", snmpService)
  .component("actionBar", actionBarComponent)
  .component("textboxPopup", textboxPopupComponent)
  .component("activity", activityComponent)
  .component("calendarPopup", calendarPopupComponent)
  .component("autoPostForm", autoPostFormComponent)
  .directive("imageLoaded", imageLoaded.directiveFactory)
  .directive("xdaCalendar", xdaCalendar.directiveFactory)
  .directive("onTap", onTap.directiveFactory);



// WEBPACK FOOTER //
// ./src/app/common/common.js